import { Input, Button, BrandIconSpinner, Select } from 'components';
import React, { useState, useEffect } from 'react';
import { AddBuinessPlaceStyle } from './Buisness.style';
import { useDispatch, useSelector } from 'react-redux';
import { addBuinessPlace } from 'redux/features/BuinessPlaceSlice';
import TextEditor from 'components/TextEditor';
import {
  getBusinessCategoryList,
  getCountryList,
} from 'redux/features/DropDownSlice';
import { Notification } from 'components/CustomNotification';
import InputAdornment from '@mui/material/InputAdornment';
import BasicChips from 'components/Chip';
import AutoComplete from 'components/AutoComplete';
import { ClearLoading, SetLoading } from 'redux/services/LoadingService';
import CheckBox from 'components/CheckBox';
import { Divider } from '@mui/material';
import { Business } from 'redux/APIEndPoint';
import { useTranslation } from 'react-i18next';
// import { UrlRegex } from 'utils/helper';

export default function AddBusinessPlace({
  closeModal,
  editData,
  handleUpdateItem,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { loading } = useSelector((state) => state.Loading);
  const { countryList, businessCategory } = useSelector(
    (state) => state?.DropdownReducer
  );
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const [textLength, setTextLength] = useState(0);
  const [state, setState] = useState({
    name: '',
    categoryId: '',
    website: '',
    title: '',
    service: '',
    contact: '',
    country: '',
    city: '',
    location: [],
    isWorldWide: false,
  });
  const [errMsg, setErrmsg] = useState({
    name: '',
    categoryId: '',
    website: '',
    title: '',
    service: '',
    contact: '',
    country: '',
  });

  const handleChange = (data, name) => {
    if (name === 'isWorldWide') {
      setState((prevState) => ({
        ...prevState,
        location: [],
      }));
    }
    setState((prevState) => ({
      ...prevState,
      [name]: data,
    }));
  };

  const handleAdd = () => {
    if (state.country) {
      setState((prevState) => ({
        ...prevState,
        location: [
          ...state.location,
          {
            country: state.country.value,
            city: state.city,
            label: state.country.label,
          },
        ],
        country: '',
        city: '',
      }));
    } else {
      Notification('error', 'Country is required');
    }
    errMsg.country = '';
    setErrmsg((prevState) => ({
      ...prevState,
    }));
  };

  const Labelname = {
    name: t('BusinessPlace.CompanyName'),
    website: t('BusinessPlace.CompanyWebsite'),
    title: t('BusinessPlace.Offer'),
    service: t('BusinessPlace.Describe'),
    country: t('BusinessPlace.Country'),
    city: t('BusinessPlace.City'),
    contact: t('BusinessPlace.ContactDetails'),
    worldWide: t('BusinessPlace.WorldWide'),
  };

  const handleValidation = () => {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = state.service;
    const textContent = tempElement.textContent.trim();

    if (textContent?.length === 0) {
      errMsg.service = 'Field Required';
    } else if (textLength > 3000) {
      errMsg.service = 'Maximum Limit 3000 only';
    } else {
      errMsg.service = '';
    }

    ['name', 'categoryId', 'website', 'title', 'contact'].forEach((data) => {
      const value = state?.[data];
      if (!value || (typeof value === 'string' && value.trim() === '')) {
        errMsg[data] = 'Field Required';
      } else {
        errMsg[data] = '';
      }
    });

    if (state.location.length === 0 && !state.isWorldWide) {
      errMsg.country = 'Add atleaset one location';
    } else {
      errMsg.country = '';
    }

    // if (
    //   state.website === '' ||
    //   !UrlRegex.test(
    //     state.website
    //   )
    // ) {
    //   errMsg.website = 'Url is Invalid';
    // } else {
    //   errMsg.website = '';
    // }

    setState((prevState) => ({
      ...prevState,
    }));
    setErrmsg((prevState) => ({
      ...prevState,
    }));
  };

  const handleSubmit = () => {
    handleValidation();
    const currentValue = ['name', 'categoryId', 'title', 'contact', 'website'];
    const validation = currentValue.every((it) => state[it] !== '');

    const tempElement = document.createElement('div');
    tempElement.innerHTML = state.service;
    const textContent = tempElement.textContent.trim();

    // console.log("isValidLink", UrlRegex.test(state.website));
    // UrlRegex.test(
    //   state.website
    // ) &&
    if (
      textContent?.length > 0 &&
      state.website &&
      validation &&
      (state.location.length > 0 || state.isWorldWide)
    ) {
      dispatch(SetLoading());
      const data = {
        name: state.name,
        categoryId: state.categoryId,
        website: state.website,
        title: state.title,
        service: state.service,
        contact: state.contact,
        isWorldWide: !!state.isWorldWide,
        email: getProfile?.userEmail,
        location:
          state?.location.length > 0
            ? JSON.stringify(
                state?.location?.map((val) => ({
                  country: val.country,
                  city: val.city,
                  label: val?.label,
                }))
              )
            : '',
      };
      dispatch(
        addBuinessPlace(
          data,
          editData ? `${Business}/${editData.id}` : Business,
          editData ? 'put' : 'post'
        )
      )
        .then((res) => {
          dispatch(ClearLoading());
          if (res.data.success === true) {
            handleClearFields();
            closeModal();
            if (editData && handleUpdateItem) {
              handleUpdateItem(res.data.data);
            }
            Notification('success', res?.data?.message);
          } else {
            Notification('error', res?.data?.message);
          }
        })
        .catch((value) => {
          dispatch(ClearLoading());
          Notification('error', value?.response?.data?.message);
        });
    }
  };

  useEffect(() => {
    countryList?.length === 0 && dispatch(getCountryList());
    businessCategory.length === 0 && dispatch(getBusinessCategoryList());
  }, []);

  useEffect(() => {
    if (editData !== null) {
      Object.keys(state).forEach((key) => {
        return setState((prevState) => ({
          ...prevState,
          [key]:
            key === 'location'
              ? typeof editData?.location === 'string'
                ? JSON.parse(editData?.location)
                : Array.isArray(editData?.location)
                ? editData?.location
                : []
              : editData?.[key] || '',
        }));
      });
    }
  }, [editData]);

  const handleLocationDelete = (deleteKey) => {
    setState((prevState) => ({
      ...prevState,
      location: state.location.filter((_, index) => index !== deleteKey),
    }));
    if (state.location.length === 1) {
      const validationParams = { ...errMsg };
      validationParams.location = 'Add atleast one location';
      setErrmsg(validationParams);
    }
  };

  const FilterLabel = (val) => {
    return countryList.filter((data) => data.value === val)?.[0]?.label;
  };

  const handleClearFields = () => {
    Object.keys(state).map((key) => {
      return setState((prevState) => ({
        ...prevState,
        [key]: '',
      }));
    });
    setErrmsg((prevState) => ({
      ...prevState,
    }));
  };

  return (
    <AddBuinessPlaceStyle>
      <BrandIconSpinner loading={loading} />
      <div>
        <div className="field-flex">
          <Input
            label={Labelname.name}
            value={state.name}
            onChange={(data) => handleChange(data, 'name')}
            errMsg={errMsg.name}
            required
            disabled={editData?.status === 1}
          />
          <Select
            Options={businessCategory}
            required
            label={t('BusinessPlace.Category')}
            value={state.categoryId}
            onChange={(data) => handleChange(data.target.value, 'categoryId')}
            errMsg={errMsg.categoryId}
          />
        </div>
        <Input
          label={Labelname.website}
          value={state.website}
          onChange={(data) => handleChange(data, 'website')}
          errMsg={errMsg.website}
          required
          maxLimit={500}
          startAdornment={
            <InputAdornment position="start">https://</InputAdornment>
          }
          disabled={editData?.status === 1}
        />
        <Input
          label={Labelname.title}
          value={state.title}
          onChange={(data) => handleChange(data, 'title')}
          errMsg={errMsg.title}
          required
        />
        <TextEditor
          label={Labelname.service}
          required
          onChange={(data) => handleChange(data, 'service')}
          value={state.service}
          errMsg={errMsg.service}
          maxLength={3000}
          callbackTextLength={setTextLength}
        />
        <Input
          label={Labelname.contact}
          value={state.contact}
          onChange={(data) => handleChange(data, 'contact')}
          errMsg={errMsg.contact}
          multiline
          required
        />
        <h3 className="location-title">{t('BusinessPlace.ServiceLocation')}</h3>
        <CheckBox
          className="worldwide-checkbox"
          label={Labelname.worldWide}
          onChange={(data) => handleChange(data, 'isWorldWide')}
          value={state.isWorldWide}
        />
        <div className="location-or">
          <Divider>OR</Divider>
        </div>
        <div className="add-flex">
          <AutoComplete
            Options={countryList}
            label={Labelname.country}
            value={state.country}
            onChange={(data) => handleChange(data, 'country')}
            disabled={state.isWorldWide || state?.country?.length >= 100}
            errMsg={errMsg.country}
            required
          />
          <div className="city-div">
            <Input
              label={Labelname.city}
              value={state.city}
              onChange={(data) => handleChange(data, 'city')}
              errMsg={errMsg.city}
              disabled={state.isWorldWide}
            />
            <Button
              type="outlined"
              disabled={state.isWorldWide || state?.location?.length >= 100}
              label={t('BusinessPlace.Add')}
              onClick={handleAdd}
            />
          </div>
        </div>

        {state?.location?.length > 0 && (
          <div className="job-chip-container">
            {state?.location?.map((item, index) => (
              <BasicChips
                key={'location_' + index}
                label={
                  item?.city
                    ? FilterLabel(item?.country) + ', ' + item.city
                    : FilterLabel(item?.country)
                }
                onDelete={() => handleLocationDelete(index)}
              />
            ))}
          </div>
        )}
      </div>
      <div className="btn_conts">
        <Button
          label={t('BusinessPlace.Cancel')}
          onClick={closeModal}
          type="text"
        />
        <Button
          label={
            editData !== ''
              ? t('BusinessPlace.Update')
              : t('BusinessPlace.Submit')
          }
          onClick={handleSubmit}
          type="text"
        />
      </div>
    </AddBuinessPlaceStyle>
  );
}
